import { render } from "./InstructionCarousel.vue?vue&type=template&id=c910331e"
import script from "./InstructionCarousel.vue?vue&type=script&lang=ts"
export * from "./InstructionCarousel.vue?vue&type=script&lang=ts"

import "./InstructionCarousel.vue?vue&type=style&index=0&id=c910331e&lang=scss"
script.render = render

export default script